import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap";
import { MDBBtn, MDBIcon } from "mdbreact";
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"
import React, { Component } from 'react';
import Select from 'react-select';

export default class ModalEnsamble extends React.Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            estadoModal: false,
            registro: _valid(this.props.registro) ? this.props.registro : undefined,
            datos: {
                departamento: undefined,
                articulo: undefined,
                estado: undefined,
                cantidad: undefined,
                observaciones: undefined,
            },
            estadoModal: true,
            listaDepartamentos: [],
            departamento2: undefined,
            fecha: undefined,
        };
        this.salir = this.salir.bind(this);
        this.guardar = this.guardar.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.departamentoLista = this.departamentoLista.bind(this);

    }

    componentDidMount() {
        //console.log(this.state.registro);
        this.departamentoLista();
        let date = new Date();
        let output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
        this.setState({ fecha: output });
    }

    departamentoLista = () => {
        if (this.apiRest.getRol()) {
            this.apiRest.get("/departamentoArea").then(response => {
                if (response.exitoso) {
                    this.setState({ listaDepartamentos: response.data });
                }
            })
        }
    }

    handleChange = ({ target: { name, value } }) => {

        this.setState({
            datos: {
                ...this.state.datos,
                [name]: value
            }
        });
    }

    guardar = () => {
        const {
            datos
        } = this.state;

        if (this.comprobarDatos()) {
            datos.articulo = this.state.registro.id;
            this.apiRest.post("/ensamble", datos).then(response => {
                if (response.exitoso) {
                    toastr.success('Se Envio Correctamente Para Ensamble');
                    this.setState({ estadoModal: false });
                } else {
                    toastr.error('ERROR AL GUARDAR');
                }
            })
        }
    }

    //comprobar que objeto datos no esta vacio
    comprobarDatos = () => {
        const {
            datos
        } = this.state;

        if (_valid(!datos.cantidad)) {
            toastr.error("Por favor, ingrese la cantidad");
        }

        if (_valid(!datos.estado)) {
            toastr.error("Por favor, ingrese asignado para");
        }

        if (_valid(!datos.observaciones)) {
            toastr.error("Por favor, ingrese las observaciones");
        }

        if (_valid(!datos.departamento)) {
            toastr.error("Por favor, ingrese el departamento");
        }

        if (_valid(datos.cantidad) && _valid(datos.departamento) && _valid(datos.estado) && _valid(datos.observaciones)) {
            return true;
        } else {
            return false;
        }
    }

    actualizarSelect = (e) => {
        this.setState({
            departamento2: e
        });
        if (_valid(e)) {
            this.setState({
                datos: {
                    ...this.state.datos,
                    departamento: e.id
                }
            });
        } else {
            this.setState({
                datos: {
                    ...this.state.datos,
                    departamento: undefined
                }
            });
        }
    }

    abrirModal = () => {
        this.setState({ estadoModal: true });
    }

    salir() {
        return this.setState({ estadoModal: false });
    }

    render() {
        const {
            registro,
            listaDepartamentos,
            datos
        } = this.state;
        return (
            <div>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Row>
                                <Col md="12">
                                    <Label htmlFor="" className="form-label">
                                        Fecha: {this.state.fecha}
                                    </Label>
                                </Col>
                            </Row>
                            <p />
                            <Row className="col-12">
                                <Col size={3}>
                                    <Label htmlFor="" className="form-label">
                                        Codigo: {_valid(registro) ? registro.codigo : "null"}
                                    </Label>
                                </Col>
                                <Col size={3}>
                                    <Label htmlFor="" className="form-label">
                                        Nombre: {_valid(registro) ? registro.nombre : "null"}
                                    </Label>
                                </Col>
                                <Col size={3}>
                                    <Label htmlFor="" className="form-label">
                                        Marca: {_valid(registro) ? registro.marca : "null"}
                                    </Label>
                                </Col>
                                <Col size={3}>
                                    <Label htmlFor="" className="form-label">
                                        Descripcion: {_valid(registro) ? registro.descripcion : "null"}
                                    </Label>
                                </Col>
                            </Row>
                            <p />
                            <Row className="col-12">
                                <Col size={6}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="departamento" className="form-label">
                                            Enviar a Departamento
                                        </Label>
                                        <Select
                                            name="departamento"
                                            options={listaDepartamentos}
                                            value={this.state.departamento2}
                                            onChange={this.actualizarSelect}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            placeholder="Selecciona.."
                                            isClearable={true}
                                            isSearchable={true}
                                            noOptionsMessage={() => "No hay opciones"}
                                        />
                                    </div>
                                </Col>
                                <Col size={6}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="cantidad" className="form-label">
                                            Cantidad
                                        </Label>
                                        <Input
                                            name="cantidad"
                                            value={datos.cantidad || ""}
                                            onChange={this.handleChange}
                                            min="0"
                                            max={registro.cantidadNoAsignadaColaborador}
                                            type="number"
                                            className="form-control"
                                            placeholder="Ingresa la cantidad"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <p />
                            <Row>
                                <Col size={6}>
                                    <Label htmlFor="estado" className="form-label">
                                        Asignado para
                                    </Label>
                                    <select
                                        value={datos.estado}
                                        onChange={this.handleChange}
                                        name="estado"
                                        className="form-control"
                                    >
                                        <option value="">Seleccione una opción</option>
                                        <option value="4">Ensamble</option>
                                        <option value="5">Almacenaciento</option>
                                    </select>
                                </Col>
                                <Col size={6}>
                                    <Label htmlFor="observaciones" className="form-label">
                                        Observaciones
                                    </Label>
                                    <Input
                                        value={datos.observaciones || ""}
                                        onChange={this.handleChange}
                                        name="observaciones"
                                        type="textarea"
                                        className="form-control"
                                        placeholder="Ingrese una observación"
                                    />
                                </Col>
                            </Row>
                            <p />
                            <Row>
                                <Col lg={12} className="text-end">
                                    {
                                        _valid(registro) && this.state.estadoModal ?
                                        <MDBBtn className="waves-effect" color="success" onClick={() => this.guardar()}>
                                            <MDBIcon icon="fas fa-paper-plane" /> {' '}
                                            Enviar
                                        </MDBBtn>
                                        : ''
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}